import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { PieChartProps } from "../../../../@types/charts/pieCharts.types";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart: React.FC<PieChartProps> = ({ data, options }) => {
	// const data = {
	// 	labels: ["Male", "Female"],
	// 	datasets: [
	// 		{
	// 			data: [30000, 20000], // Replace these values with your actual gender ratio data
	// 			backgroundColor: ["#6b9ac4", "#4059ad"],
	// 			hoverBackgroundColor: ["#81b3df", "#617acc"]
	// 		}
	// 	]
	// };

	// const options = {
	// 	plugins: {
	// 		legend: {
	// 			display: true,
	// 			position: "bottom"
	// 		}
	// 	}
	// };

	return (
		<div>
			{/* <h2>Gender Ratio</h2> */}
			<Pie data={data} options={options as unknown as any} />
		</div>
	);
};

export default PieChart;
